<script setup lang="ts"></script>

<template>
  <footer
    class="mx-6 flex justify-between border-t border-t-gray-200 p-6 text-sm font-extralight text-neutral-800"
  >
    <span>Cabeza, Feliciano | Sociedade de Advogados</span>
    <span>© 2025 Associação de Advocacia</span>
  </footer>
</template>

<style scoped></style>
